<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
         <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">404</h1>
            <h4 class="pt-3">Oups!</h4>
            <p class="text-muted"><i>(cette page est manquante ou inexistante)</i></p>
            <h4>Quelqu'un a débranché la prise!</h4>
              <a href="/" class="badge badge-info p-2"><i class="fa fa-arrow-right mr-2"></i>Acceuil</a>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>
